import { useEffect, useState } from 'react'

/**
 * Atrasa a propagação de um valor.
 *
 * Usado no campo "Busca..." das listagens: sem isso, cada tecla dispara uma
 * consulta ao servidor com trigram sobre nome, telefone e e-mail — e o resultado
 * da terceira letra pode chegar depois do da quinta, pintando a lista errada.
 */
export function useDebounce<T>(valor: T, atrasoMs = 350): T {
  const [atrasado, setAtrasado] = useState(valor)

  useEffect(() => {
    const temporizador = window.setTimeout(() => setAtrasado(valor), atrasoMs)
    return () => window.clearTimeout(temporizador)
  }, [valor, atrasoMs])

  return atrasado
}
